import React, { Component } from "react";
import { CallAPI, HandleTextChange, parseIntFromStr, GetCookieFunction } from '../../utils/util';
import Alert from 'react-bootstrap/Alert';
import { PatientNav } from './patientnav';
import { FunnelNav } from './funnelNav';
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import VoiceInput from '../../utils/VoiceInput';

function withRouter(Component) {
    function ComponentWithRouterProp(props) {
        let location = useLocation();
        let navigate = useNavigate();
        let params = useParams();
        let [searchParams] = useSearchParams();

        return (
            <Component
                {...props}
                router={{ location, navigate, params, searchParams }}
            />
        );
    }
    return ComponentWithRouterProp;
}

class AssessmentPlan extends Component {
    constructor(props) {
        super(props);
        this.state = {
            "rows": {},
            "patientID": parseIntFromStr(this.props.router.params.patientId),
            "staffID": GetCookieFunction("User").id,
            "modalVariant": "",
            "modalMessage": ""
        };

        this.handleTextChange = HandleTextChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);

        // Is this page being access as a funnel mode?
        this.funnel = this.props.router.searchParams.get('funnel') ? "?funnel=1" : "";
    };

    componentDidMount() {
        CallAPI({}, `patients/${this.state.patientID}/assessmentPlan`, 'GET', (res) => {
            var orders = undefined;
            if (!res){
                console.log("No results found");    // Should not happen.
                orders = {};
            } else {
                orders = res;
            }
            this.setState({"rows": orders})
        }, (message) => {
            this.setState({
                "modalVariant": "danger",
                "modalMessage": "Error loading patient data: " + message.message
            })
        });
    }

    handleSubmit(event) {
        event.preventDefault();

        CallAPI(
            {
                "rows": this.state.rows, 
                "patientID": this.state.patientID,
                "staffID": this.state.staffID
            }, 
            `patients/${this.state.patientID}/assessmentPlan`, 'PUT', (res) => {
                if (this.funnel){
                    if (GetCookieFunction("User").type === "doctor"){
                        this.props.router.navigate("/patients/" + this.state.patientID + "/dialysisOrder"+this.funnel);
                    } else {
                        this.props.router.navigate("/patients/" + this.state.patientID + "/profile");
                    }
                } else {
                    this.setState({
                        "modalVariant": "success",
                        "modalMessage": "Patient assessment and plan have been saved."
                    });
                }
            },
            (message) => {
                this.setState({
                    "modalVariant": "danger",
                    "modalMessage": "Patient assessment and plan could not be saved."
                })
            }
        );
    };

    render = () => {
        return (
            <div>
                <PatientNav patientId={this.state.patientID} />
                <div className="ci-page">
                    {this.funnel && <FunnelNav patientId={this.state.patientID} currentStep={8} />}
                    <div className="ci-header">
                        <h2>Assessment &amp; Treatment Plan</h2>
                        <p>Document clinical assessment and treatment plan</p>
                    </div>
                    {this.state.modalVariant && (
                        <Alert variant={this.state.modalVariant} className="ci-alert">{this.state.modalMessage}</Alert>
                    )}
                    <form onSubmit={(e) => this.handleSubmit(e)}>
                        <div className="ci-card">
                            <div className="ci-field">
                                <label htmlFor="Assessment">Assessment</label>
                                <div className="ci-field-with-voice">
                                    <textarea id="Assessment" name="Assessment" maxLength="1024" rows={5}
                                        placeholder="Clinical assessment..."
                                        value={this.state.rows.Assessment || ""}
                                        onChange={(e) => this.handleTextChange(e, "rows")} />
                                    <VoiceInput language="en" onTranscript={(text) => {
                                        this.setState(prev => ({
                                            rows: { ...prev.rows, Assessment: (prev.rows.Assessment || "") + (prev.rows.Assessment ? " " : "") + text }
                                        }));
                                    }} />
                                </div>
                            </div>
                        </div>
                        <div className="ci-card">
                            <div className="ci-field">
                                <label htmlFor="TreatmentPlan">Treatment Plan</label>
                                <div className="ci-field-with-voice">
                                    <textarea id="TreatmentPlan" name="TreatmentPlan" maxLength="1024" rows={5}
                                        placeholder="Treatment plan..."
                                        value={this.state.rows.TreatmentPlan || ""}
                                        onChange={(e) => this.handleTextChange(e, "rows")} />
                                    <VoiceInput language="en" onTranscript={(text) => {
                                        this.setState(prev => ({
                                            rows: { ...prev.rows, TreatmentPlan: (prev.rows.TreatmentPlan || "") + (prev.rows.TreatmentPlan ? " " : "") + text }
                                        }));
                                    }} />
                                </div>
                            </div>
                        </div>
                        <div className="ci-submit-row">
                            <button type="submit" className="logSubmit ci-submit-btn">Save Changes</button>
                        </div>
                    </form>
                </div>
            </div>
        );
    };
}

export default withRouter(AssessmentPlan)